import { render, staticRenderFns } from "./points_distribution_rules.vue?vue&type=template&id=36ea4fb6"
import script from "./points_distribution_rules.vue?vue&type=script&lang=js"
export * from "./points_distribution_rules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports